import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { selectDraftBoardForm } from "../../../../components/Settings/redux/selector";
import { selectUserFormData } from "app/redux/selector";
import { selectTicketGroups } from "../../../Tickets/redux/selector";
import { ticketGroupsActions } from "../../../Tickets/redux/slice";
import { useBoardsActions } from "../../../../components/useBoardsActions";
import { GroupAction } from "../../../../types";
import { TicketGroup } from "../../../Tickets/types";

interface Props {
  group: TicketGroup;
  setIsGroupModalOpen: (val: GroupAction) => void;
  setIsRemoveGroup: (val: boolean) => void;
}

export default function useListGroupActions({
  setIsGroupModalOpen,
  setIsRemoveGroup,
}: Props) {
  const dispatch = useDispatch();

  const { _id: boardId } = useSelector(selectDraftBoardForm);
  const { selectedProjectId } = useSelector(selectUserFormData);
  const groupData = useSelector(selectTicketGroups);

  const { updateBoardsGroupsJson } = useBoardsActions(selectedProjectId);

  const hiddenGroups = useMemo(
    () => groupData?.filter((g) => !g.isVisible) ?? [],
    [groupData],
  );

  const updateGroup = useCallback(
    (group,payload) => {
      dispatch(
        ticketGroupsActions.updateGroupActions({
          ...group,
          ...payload,
        }),
      );

      updateBoardsGroupsJson(boardId, () => {});
    },
    [dispatch, boardId, updateBoardsGroupsJson],
  );

  const handleClick = useCallback(
    (type: GroupAction, group: TicketGroup) => {
      switch (type) {
        case GroupAction.COLLAPSE:
          updateGroup(group, {isCollapse: true});
          break;

        case GroupAction.UN_COLLAPSE:
          updateGroup(group, {isCollapse: false});
          break;

        case GroupAction.HIDE:
          updateGroup(group, {isVisible: false});
          break;
        case GroupAction.UN_HIDE:
          updateGroup(group, {isVisible: true});
          break;

        case GroupAction.ADD:
        case GroupAction.EDIT:
          setIsGroupModalOpen(type);
          break;

        case GroupAction.REMOVE:
          setIsRemoveGroup(true);
          break;
      }
    },
    [updateGroup, setIsGroupModalOpen, setIsRemoveGroup],
  );

  return { handleClick, hiddenGroups };
}
